/**
 * @see https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
 */
export function createMarkup(html: string) {
  html = cleanupText(html);
  return { __html: html };
}

export function cleanupText(text: string): string;
export function cleanupText(text: undefined): undefined;
export function cleanupText(text: string | undefined): string | undefined;
export function cleanupText(text: null): null;
export function cleanupText(text: string | undefined | null) {
  return text ? text.replace(/\\([()])/g, "$1") : text;
}

export function renderAsHTML(html: string) {
  return <div className={"scha__cmssection__html"} dangerouslySetInnerHTML={createMarkup(html)} />;
}
